import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { LabelWeights, LabelSizes, LabelVariants, } from "../../../Atoms/Text/Label/constants";
import { StyledFilterTag, StyledFilterTagContent, StyledIcon, } from "./FilterTag.style";
import { NumberBadgeVariants } from "../../../Atoms/Tags/NumberBadge/constants";
import { Contrast } from "../../../types/general.types";
import { IconSizes, IconVariants } from "../../Images/Icon/constants";
import { ICON_ARROW_DOWN } from "./constants";
import { handleChangeCheckbox } from "@icarros/utils-react";
import { Label, NumberBadge } from "../../../Atoms";
import { useState } from "react";
const FilterTag = ({ text, badgeValue, contrast = Contrast.default, icon, customIconName, onIconClick = () => { }, isDisabled = false, onChange = () => { }, checked = false, ...props }) => {
    const [onHover, setOnHover] = useState(false);
    const onInternalChange = (checked, name) => {
        if (!isDisabled) {
            onChange(checked, name);
        }
    };
    const getLabelProps = (isDisabled, contrast) => {
        const labelProps = {
            weight: LabelWeights.regular,
            size: LabelSizes.small,
        };
        switch (contrast) {
            case Contrast.dark:
                if (isDisabled)
                    return {
                        ...labelProps,
                        variant: LabelVariants.neutral,
                        contrast: Contrast.dark,
                        isDisabled: isDisabled,
                    };
                return checked
                    ? {
                        ...labelProps,
                        variant: LabelVariants.neutral,
                        contrast: Contrast.light,
                    }
                    : {
                        ...labelProps,
                        variant: LabelVariants.neutral,
                        contrast: Contrast.dark,
                    };
            case Contrast.light:
                if (isDisabled)
                    return {
                        ...labelProps,
                        variant: LabelVariants.neutral,
                        contrast: Contrast.dark,
                        isDisabled: isDisabled,
                    };
                return checked
                    ? {
                        ...labelProps,
                        variant: LabelVariants.neutral,
                        contrast: Contrast.dark,
                    }
                    : {
                        ...labelProps,
                        variant: LabelVariants.neutral,
                        contrast: Contrast.light,
                    };
            default:
                if (isDisabled)
                    return {
                        ...labelProps,
                        variant: LabelVariants.neutral,
                        contrast: Contrast.default,
                        isDisabled: isDisabled,
                    };
                return checked
                    ? {
                        ...labelProps,
                        variant: LabelVariants.neutral,
                        contrast: Contrast.dark,
                    }
                    : {
                        ...labelProps,
                        variant: LabelVariants.secondary,
                        contrast: Contrast.default,
                        isVariant: onHover,
                    };
        }
    };
    const getNumberBadgeProps = (contrast) => {
        const numberBadgeProps = {
            lockMobile: true,
        };
        switch (contrast) {
            case Contrast.dark:
                return checked
                    ? {
                        ...numberBadgeProps,
                        variant: NumberBadgeVariants.neutral,
                        contrast: Contrast.light,
                    }
                    : {
                        ...numberBadgeProps,
                        variant: NumberBadgeVariants.neutral,
                        contrast: Contrast.dark,
                    };
            case Contrast.light:
                return checked
                    ? {
                        ...numberBadgeProps,
                        variant: NumberBadgeVariants.neutral,
                        contrast: Contrast.dark,
                    }
                    : {
                        ...numberBadgeProps,
                        variant: NumberBadgeVariants.neutral,
                        contrast: Contrast.default,
                    };
            default:
                return checked
                    ? {
                        ...numberBadgeProps,
                        variant: NumberBadgeVariants.secondary,
                        contrast: Contrast.dark,
                    }
                    : {
                        ...numberBadgeProps,
                        variant: NumberBadgeVariants.secondary,
                        contrast: Contrast.default,
                    };
        }
    };
    const getIconProps = (isDisabled, contrast) => {
        const iconProps = {
            size: IconSizes.small,
        };
        switch (contrast) {
            case Contrast.dark:
                if (isDisabled)
                    return {
                        ...iconProps,
                        variant: IconVariants.neutral,
                        contrast: Contrast.dark,
                        isDisabled: isDisabled,
                    };
                return checked
                    ? {
                        ...iconProps,
                        variant: IconVariants.neutral,
                        contrast: Contrast.light,
                    }
                    : {
                        ...iconProps,
                        variant: IconVariants.neutral,
                        contrast: Contrast.dark,
                        isColorVariant: onHover,
                    };
            case Contrast.light:
                if (isDisabled)
                    return {
                        ...iconProps,
                        variant: IconVariants.neutral,
                        contrast: Contrast.light,
                        isDisabled: isDisabled,
                    };
                return checked
                    ? {
                        ...iconProps,
                        variant: IconVariants.neutral,
                        contrast: Contrast.dark,
                    }
                    : {
                        ...iconProps,
                        variant: IconVariants.neutral,
                        contrast: Contrast.light,
                        isColorVariant: onHover,
                    };
            default:
                if (isDisabled)
                    return {
                        ...iconProps,
                        variant: IconVariants.neutral,
                        contrast: Contrast.default,
                        isDisabled: isDisabled,
                    };
                return checked
                    ? {
                        ...iconProps,
                        variant: IconVariants.neutral,
                        contrast: Contrast.dark,
                    }
                    : {
                        ...iconProps,
                        variant: IconVariants.secondary,
                        contrast: Contrast.default,
                    };
        }
    };
    return (_jsxs(StyledFilterTag, { onMouseEnter: () => setOnHover(true), onMouseLeave: () => setOnHover(false), children: [_jsx("input", { ...props, id: `ids-react-filter-tag-${text}`, type: "checkbox", onChange: (e) => handleChangeCheckbox(e, onInternalChange) }), _jsxs(StyledFilterTagContent, { onHover: onHover, isDisabled: isDisabled, checked: checked, contrast: contrast, htmlFor: `ids-react-filter-tag-${text}`, children: [_jsx(Label, { ...getLabelProps(isDisabled, contrast), children: text }), badgeValue &&
                        !isNaN(parseInt(badgeValue)) &&
                        !icon &&
                        !customIconName && (_jsx(NumberBadge, { ...getNumberBadgeProps(contrast), value: parseInt(badgeValue) > 99 ? "99+" : badgeValue })), (icon || customIconName) && (_jsx(StyledIcon, { ...getIconProps(isDisabled, contrast), name: customIconName || ICON_ARROW_DOWN, onClick: onIconClick }))] })] }));
};
export default FilterTag;
//# sourceMappingURL=FilterTag.js.map